import React from 'react';

import {useI18n} from '@udemy/i18n';
import AppleIcon from '@udemy/icons/dist/apple.ud-icon';
import GoogleIcon from '@udemy/icons/dist/google.ud-icon';
import OutlookIcon from '@udemy/icons/dist/outlook.ud-icon';
import {Button} from '@udemy/react-core-components';

import styles from './tired-step.module.less';

export interface TiredStepCalendarSyncProps {
    isGoogleAvailable: boolean;
    isGoogleLoading: boolean;
    error: string | null;
    onGoogleClick: () => void;
    onIcsDownload: () => void;
}

export function TiredStepCalendarSync({
    isGoogleAvailable,
    isGoogleLoading,
    error,
    onGoogleClick,
    onIcsDownload,
}: TiredStepCalendarSyncProps) {
    const {gettext} = useI18n();

    return (
        <div className={styles['content']}>
            <h2 className="ud-heading-xl">{gettext("Done! We'll remind you.")}</h2>
            {error && (
                <p className={styles['error']} role="alert">
                    {error}
                </p>
            )}
            <p className="ud-heading-md">{gettext('Add to calendar (optional)')}</p>
            <div className={styles['calendar-options']}>
                {isGoogleAvailable && (
                    <Button
                        udStyle="secondary"
                        size="medium"
                        className={styles['calendar-button']}
                        disabled={isGoogleLoading}
                        onClick={onGoogleClick}
                    >
                        <GoogleIcon label="" className={styles['calendar-icon']} />
                        {gettext('Sign in with Google')}
                    </Button>
                )}
                <Button
                    udStyle="secondary"
                    size="medium"
                    className={styles['calendar-button']}
                    onClick={onIcsDownload}
                >
                    <AppleIcon label="" className={styles['calendar-icon']} />
                    {gettext('Apple')}
                </Button>
                <Button
                    udStyle="secondary"
                    size="medium"
                    className={styles['calendar-button']}
                    onClick={onIcsDownload}
                >
                    <OutlookIcon label="" className={styles['calendar-icon']} />
                    {gettext('Outlook')}
                </Button>
            </div>
            <p className="ud-text-sm">
                {gettext(
                    'Apple and Outlook will download an .ics file. Open it to add the event to your calendar.',
                )}
            </p>
        </div>
    );
}
